export default {
  path: ":alias/student-comments",
  component: resolve => require(["@/views/student-comments"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/student-comments/list"], resolve)
    }
  ]
};
